import { render } from "./EtapaProcessoVendasModal.vue?vue&type=template&id=5047ec08&scoped=true&ts=true"
import script from "./EtapaProcessoVendasModal.vue?vue&type=script&lang=ts"
export * from "./EtapaProcessoVendasModal.vue?vue&type=script&lang=ts"

import "./EtapaProcessoVendasModal.vue?vue&type=style&index=0&id=5047ec08&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5047ec08"]])

export default __exports__